export default "__VITE_ASSET__MPJr$fbz__"